import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
    FormComponent,
    EmailInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';

import { passwordResetInit } from '../../../services/authentication/resetpassword/actions';
import { withTemplate } from '../../template/withTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import HeadComponent from '../../HeadComponent';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';

class PasswordResetInitFormComponent extends React.Component {
    handleSubmit = data => {
        this.props.passwordResetInit(data);
    };

    renderForm = () => {
        const { i18n, requestSubmit, successSubmit, errorSubmit, errorMessage } = this.props;

        if (!successSubmit) {
            return (
                <FormComponent
                    form="password-reset-init-form"
                    onSubmit={this.handleSubmit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    submitText={i18n.form.SUBMIT}>
                    <EmailInputFieldComponent
                        name="email"
                        placeholder={i18n.form.placeholder.EMAIL}
                        isRequired
                    />
                    {errorMessage && (
                        <LegendFieldComponent classNameInputContainer="color-err">
                            {errorMessage}
                        </LegendFieldComponent>
                    )}
                </FormComponent>
            );
        }
    };

    renderSuccessMessage = () => {
        const { successSubmit, i18n } = this.props;
        if (successSubmit) {
            return (
                <SuccessInfoComponent>
                    <p>{i18n.form.SUCESS_MESSAGE}</p>
                </SuccessInfoComponent>
            );
        }
    };

    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to="/password-reset">
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>
                <p>{i18n.SUBTITLE}</p>
                {this.renderForm()}
                {this.renderSuccessMessage()}
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.PASSWORDRESET.INITIALIZATION,
        errorMessage: state.authentication.resetpassword.error || '',
        requestSubmit: state.authentication.resetpassword.fetching || false,
        successSubmit: state.authentication.resetpassword.successPasswordResetInit || false,
        errorSubmit: !_.isEmpty(state.authentication.resetpassword.error)
    };
};

const mapDispatchToProps = {
    passwordResetInit
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(PasswordResetInitFormComponent),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/resetpassword/PasswordResetInitFormComponent.js